import React from 'react';
import analyticsLocales from '../locales/analytics.json';
import {addLocaleData, IntlProvider} from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import Main from './analytics_components/Main';
import Root from './analytics_components/stores/Root.js';
import {Provider} from 'mobx-react';

addLocaleData([...es, ...en]);
export default class Analytics extends React.Component {

    constructor(props) {
        super(props);
        this.rootStore = new Root();
    }


    render() {
        const locale = this.props.locale;
        const messages = analyticsLocales[locale];

        return (
            <Provider
                rootStore={this.rootStore}
                getStore={this.rootStore.getStore}
                growStore={this.rootStore.growStore}
                keepStore={this.rootStore.keepStore}>
                <IntlProvider
                    locale={locale}
                    messages={messages}>
                    <Main {...this.props} />
                </IntlProvider>
            </Provider>

        );
    }
}

